$(function() {
    /*================================= 
    Owl Carousel  -- HOME
    ==================================*/
    $('#owl-home').owlCarousel({
        autoWidth: false,
        nav: true,
        items:1,
        navText: ['<span class="icon-angle_left"></span>', '<span class="icon-angle_right"></span>'],
        dots: true,
        loop: true,
        margin: 10,
        autoHeight: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsiveClass: true
    });
    $('#owl-momentos').owlCarousel({
        autoWidth: false,
        nav: false,
        items:1,
        navText: ['<span class="icon-angle_left"></span>', '<span class="icon-angle_right"></span>'],
        dots: false,
        loop: false,
        autoHeight: true,
    });
    $('#owl-momentos_ficha').hide();
    $('#owl-agencias').hide();
    $('#owl-agencia_ficha').hide();
    $('#owl-blog').hide();
    $('#owl-post').hide();
});


// WEBPACK FOOTER //
// ./assets/js/carousel.js